module.exports = __webpack_public_path__ + "static/img/note_1.c7b5be0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/note_1.png
// module id = a7uv
// module chunks = 1